import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import './wompi-checkout.css'

type Copy = Record<string, string>

type CheckoutConfig = {
  status: boolean
  redirect?: string | null
  usd_label?: string
  coins?: number
  lang?: string
  plan_id?: string
  session_id?: string
  checkout_url?: string
  return_url?: string
  copy?: Copy
  message?: string
}

export function WhopCheckoutPage() {
  const { orderId = '' } = useParams()
  const [params] = useSearchParams()
  const [config, setConfig] = useState<CheckoutConfig | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    const session = config?.session_id || ''
    if (!session.startsWith('ch_')) return
    const target = String(config?.checkout_url || '')
    const url = target.startsWith('https://')
      ? target
      : `https://whop.com/checkout/${encodeURIComponent(session)}/`
    window.location.replace(url)
  }, [config?.session_id, config?.checkout_url])

  useEffect(() => {
    const lang = params.get('lang') || 'es'
    let stop = false
    fetch(`/api/whop/checkout/${encodeURIComponent(orderId)}?lang=${encodeURIComponent(lang)}`)
      .then(async (res) => {
        const body = await res.json()
        if (!res.ok) throw new Error(body.message || 'Pago no encontrado')
        return body as CheckoutConfig
      })
      .then((body) => {
        if (stop) return
        if (body.redirect) {
          window.location.replace(body.redirect)
          return
        }
        setConfig(body)
      })
      .catch((err: Error) => {
        if (!stop) setError(err.message || 'Pago no encontrado')
      })
    return () => { stop = true }
  }, [orderId, params])

  const copy = config?.copy || {}
  const lang = config?.lang === 'en' ? 'en' : 'es'

  return (
    <div className="wompi-shell">
      <div className="wompi-wrap">
        {!config && !error && <p className="wompi-coins">…</p>}
        {error && !config && <p className="wompi-alert on">{error}</p>}
        {config && !String(config.session_id || '').startsWith('ch_') && (
          <p className="wompi-alert on">
            {lang === 'en' ? 'Checkout could not be opened.' : 'No se pudo abrir el pago.'}
          </p>
        )}
        {config && String(config.session_id || '').startsWith('ch_') && (
          <header className="wompi-summary">
            <p className="wompi-merchant">Whop</p>
            <div className="wompi-usd">${config.usd_label} <i>USD</i></div>
            {copy.coins && <p className="wompi-coins">{copy.coins}</p>}
            <p className="wompi-coins">{lang === 'en' ? 'Opening checkout…' : 'Abriendo el pago…'}</p>
          </header>
        )}
      </div>
    </div>
  )
}
